import initMemberPage from './members';

const initPage =() => {
	initMemberPage();
};

const initFrontScript = () => {
	if ( document.readyState !== 'loading' ) {
		initPage();
	} else {
		document.addEventListener( 'DOMContentLoaded', initPage );
	}
};

export default initFrontScript;